import { createJSONStorage } from 'zustand/middleware';
import { jsonReplacer, jsonReviver, stateStorage } from '@/lib/storage';
import { useAuthStore } from '@/stores/authStore';

export const persistStorage = <T>() =>
  createJSONStorage<T>(() => stateStorage, {
    replacer: jsonReplacer,
    reviver: jsonReviver,
  });

/**
 * Storage adapter that suppresses writes when Firestore sync is active.
 * Reads still work (needed for initial hydration before auth resolves).
 */
export const conditionalPersistStorage = <T>() =>
  createJSONStorage<T>(
    () => ({
      getItem: (name) => stateStorage.getItem(name),
      setItem: (name, value) => {
        if (useAuthStore.getState().authMode === 'authenticated') return;
        return stateStorage.setItem(name, value);
      },
      removeItem: (name) => stateStorage.removeItem(name),
    }),
    { replacer: jsonReplacer, reviver: jsonReviver },
  );
